import { render, staticRenderFns } from "./ArticlePreviewer.vue?vue&type=template&id=2ea1def0&scoped=true&"
import script from "./ArticlePreviewer.vue?vue&type=script&lang=js&"
export * from "./ArticlePreviewer.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePreviewer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ArticlePreviewer.vue?vue&type=style&index=1&id=2ea1def0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1def0",
  null
  
)

export default component.exports